<template>
  <div class="page-wrap">

    <div class="cards-row">

      <!-- ── Current Plan Card ── -->
      <div v-if="currentPlan && currentPlan.plan" class="plan-card plan-card--current">
        <div class="pc-badge pc-badge--current">Currently Active</div>

        <div class="pc-icon">
          <v-icon size="22" color="var(--brand)">mdi-star-circle-outline</v-icon>
        </div>

        <h3 class="pc-title">{{ currentPlan.plan.title }}</h3>

        <div class="pc-price">
          <span class="pc-currency">₹</span>
          <span class="pc-amount">{{ Number(currentPlan.amount).toLocaleString('en-IN') }}</span>
        </div>

        <ul class="pc-features">
          <li>
            <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
            Full Society Access
          </li>
          <li>
            <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
            Automated Billing
          </li>
          <li>
            <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
            Member Notifications
          </li>
          <li>
            <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
            Visitor Management
          </li>
          <li>
            <v-icon size="14" color="#64748B">mdi-calendar-outline</v-icon>
            Start date {{ getFormattedDate(currentPlan.start_date) }}
          </li>
          <li>
            <v-icon size="14" color="#64748B">mdi-calendar-outline</v-icon>
            Renews {{ getFormattedDate(currentPlan.expiration_date) }}
          </li>
          <li v-if="planDay > 0">
            <v-icon size="14" color="#F59E0B">mdi-clock-outline</v-icon>
            {{ planDay }} Days Remaining
          </li>
        </ul>

        <button class="pc-btn pc-btn--current" disabled>
          <v-icon size="15" class="mr-1">mdi-check</v-icon>
          Current Plan
        </button>
      </div>

      <!-- ── Available Plan Cards ── -->
      <!-- FIXED: v-if ને વાઇપર <template> પર મૂક્યો અને v-for ને div પર રાખ્યો જેથી ESLint એરર ન આવે -->
      <template v-if="textShow === true && showPlan === true">
        <div
          v-for="item in planData"
          :key="item.id"
          class="plan-card"
          :class="{
            'plan-card--active': currentPlan && item.id === currentPlan.plan_id,
            'plan-card--popular': item.identifier === 'year'
          }"
        >
          <!-- ── Badge Logic ── -->
          <div class="pc-badge pc-badge--next">
            Next Plan
          </div>

          <div class="pc-icon">
            <v-icon size="22" :color="currentPlan && item.id === currentPlan.plan_id ? 'var(--brand)' : '#94A3B8'">
              mdi-star-four-points-outline
            </v-icon>
          </div>

          <h3 class="pc-title">{{ item.title }}</h3>

          <div class="pc-price">
            <span class="pc-currency">₹</span>
            <span class="pc-amount">{{ Number(item.restAmount || item.amount).toLocaleString('en-IN') }}</span>
            <span class="pc-per">/{{ item.number_of_days }} days</span>
          </div>

          <div v-if="item.totalAmount && item.lessAmount" class="pc-original">
            ₹{{ Number(item.totalAmount).toLocaleString('en-IN') }}
            <span class="pc-save">Save ₹{{ Number(item.lessAmount).toLocaleString('en-IN') }}</span>
          </div>

          <ul class="pc-features">
            <li>
              <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
              Full Society Access
            </li>
            <li>
              <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
              Automated Billing
            </li>
            <li>
              <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
              Member Notifications
            </li>
            <li>
              <v-icon size="14" color="#10B981">mdi-check-circle</v-icon>
              Visitor Management
            </li>
            <li>
              <v-icon size="14" color="#64748B">mdi-information-outline</v-icon>
              ₹{{ item.amount }} Per Unit
            </li>
          </ul>

          <button
            class="pc-btn"
            :class="{
              'pc-btn--current': currentPlan && item.id === currentPlan.plan_id,
              'pc-btn--upgrade': !(currentPlan && item.id === currentPlan.plan_id)
            }"
            :disabled="currentPlan && item.id === currentPlan.plan_id"
            @click="currentPlan && item.id === currentPlan.plan_id ? null : purchasePlan(item)"
          >
            <v-icon v-if="currentPlan && item.id === currentPlan.plan_id" size="15" class="mr-1">mdi-check</v-icon>
            {{ currentPlan && item.id === currentPlan.plan_id ? 'Current Plan' : 'Upgrade Society' }}
          </button>
        </div>
      </template>

    </div>

  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: 'MyPlans',
  data() {
    return {
      planData: [],
      currentPlan: {},
      nextPlan: {},
      showPlan: false,
      planDay: 0,
      textShow: false,
      userPlan: {},
      planPrice: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState('theme', ['isDark', 'primaryColor']),
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getPlan() {
      this.$axios.get("societyadmin/plans").then((response) => {
        let data = response.data;
        if (data.status) {
          this.planData = data.Plan;
        } else {
          this.showError(data.message);
        }
      });
    },

    getUserPlan() {
      this.$axios.get("societyadmin/user-plan").then((response) => {
        let data = response.data;
        if (data.status) {
          this.currentPlan = data.current || {};
          this.nextPlan    = data.next    || {};
          this.showPlan    = data.showPlan;
          this.textShow    = data.textShow;
          this.planDay     = data.planDay;
          this.userPlan    = data.planData;
          this.planPrice   = data.planPrice;
          if (!data.isExpired) {
            localStorage.removeItem("isPlanExpired");
          } else {
            localStorage.setItem("isPlanExpired", "true");
          }
        } else {
          this.showError(data.message);
        }
      });
    },

    purchasePlan(item) {
      if (!window.Cashfree) {
        this.showError("Cashfree SDK not loaded");
        return;
      }
      this.loading = true;
      const cashfree = window.Cashfree({
        mode: process.env.VUE_APP_CASHFREE_MODE || "sandbox",
      });
      this.$axios.post("/societyadmin/createOrder", { plan_id: item.id, amount: item.restAmount,total_count: item.total_count })
        .then((response) => {
          let data = response.data;
          if (data.status && data.data.payment_session_id) {
            cashfree.checkout({ paymentSessionId: data.data.payment_session_id, redirectTarget: "_self" });
          } else {
            this.loading = false;
            this.showError(data.message || "Failed to initiate payment");
          }
        })
        .catch(() => { this.loading = false; this.showError("Something went wrong"); });
    },

    handlePaymentReturn() {
      const orderId = this.$route.query.order_id;
      if (orderId) {
        this.loading = true;
        this.$axios.post("/societyadmin/verifyPayment", { order_id: orderId })
          .then((response) => {
            this.loading = false;
            let data = response.data;
            if (data.status) {
              this.setAlert({ showAlert: true, message: "Payment Successful!", variant: "green accent-4", timeout: 3000 });
              this.getUserPlan();
              this.$router.replace({ path: this.$route.path, query: {} });
            } else {
              this.showError(data.message || "Payment verification failed");
            }
          })
          .catch(() => { this.loading = false; this.showError("Verification error"); });
      }
    },

    getFormattedDate(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
    },

    showError(msg) {
      this.setAlert({ showAlert: true, variant: "red accent-3", timeout: "2000", message: msg });
    }
  },
  mounted() {
    this.getPlan();
    this.getUserPlan();
    this.handlePaymentReturn();
  },
};
</script>

<style scoped>
.page-wrap {
 padding: 32px 24px;
  display: flex;
  /* justify-content: center; */
  width: 100%;
}

/* ── Cards Row ── */
.cards-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
 justify-content: flex-start;
  width: 100%;
  max-width: 1200px;
}

/* ── Plan Card ── */
.plan-card {
  flex: 1 1 320px;
  max-width: 550px;
  width: 100%;
  background: var(--surface, #fff);
  border: 1.5px solid var(--border, #E2E8F0);
  border-radius: 18px;
  padding: 32px 24px 24px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 18px;
  transition: box-shadow 0.2s, transform 0.2s;
  box-sizing: border-box;
}
.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(0,0,0,0.08);
}

.plan-card--current {
  border: 2px solid var(--brand, #0D9972);
  box-shadow: 0 4px 24px rgba(13,153,114,0.10);
}

.plan-card--active {
  border: 2px solid var(--brand, #0D9972);
  box-shadow: 0 4px 24px rgba(13,153,114,0.10);
}

.plan-card--popular {
  border: 2px solid var(--brand, #0D9972);
}

/* ── Badge Pill Layout ── */
.pc-badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 20px;
  border-radius: 30px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
  z-index: 1;
  border: none;
}

.pc-badge--current {
  background: var(--brand, #0D9972);
  color: #fff;
}
.pc-badge--popular {
  background: var(--brand, #0D9972);
  color: #fff;
}
.pc-badge--active {
  background: var(--brand, #0D9972);
  color: #fff;
}

.pc-badge--next {
  background: #FF6B6B;
  color: #fff;
}

/* ── Icon ── */
.pc-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--surface2, #F8FAFC);
  border: 1px solid var(--border, #E2E8F0);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

/* ── Title ── */
.pc-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--tx, #111827);
  margin: 0 0 10px;
  letter-spacing: -0.01em;
}

/* ── Price ── */
.pc-price {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  margin-bottom: 4px;
}
.pc-currency {
  font-size: 18px;
  font-weight: 700;
  color: var(--tx2, #475569);
  margin-bottom: 6px;
}
.pc-amount {
  font-size: 40px;
  font-weight: 900;
  color: var(--tx, #111827);
  line-height: 1;
  letter-spacing: -0.03em;
}
.pc-per {
  font-size: 13px;
  font-weight: 600;
  color: var(--tx3, #94A3B8);
  margin-bottom: 6px;
  margin-left: 4px;
}

/* ── Original / Save ── */
.pc-original {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--tx4, #CBD5E1);
  text-decoration: line-through;
  margin-bottom: 4px;
}
.pc-save {
  text-decoration: none;
  background: rgba(16,185,129,0.1);
  color: #10B981;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

/* ── Features ── */
.pc-features {
  list-style: none;
  padding: 0;
  margin: 20px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}
.pc-features li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--tx2, #475569);
}

/* ── Button ── */
.pc-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.pc-btn--upgrade {
  background: var(--brand, #0D9972);
  color: #fff;
}
.pc-btn--upgrade:hover {
  filter: brightness(1.08);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(13,153,114,0.25);
}
.pc-btn--current {
  background: rgba(13,153,114,0.08);
  color: var(--brand, #0D9972);
  cursor: default;
  border: 1px solid rgba(13,153,114,0.2);
}
</style>